exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.location-row{width:100%;height:36px;background-color:#fff;padding:9px 0}.location-row .location-underline{display:flex;flex-direction:row;width:auto;padding:0 8px}.location-row .location-underline .location-icon{background-image:url(" + require("../../../../../assets/images/map-icon.svg") + ");background-repeat:no-repeat;width:24px;height:21px;padding-right:8px;margin-top:10px;padding-bottom:8px;border-bottom:1px solid #184e78;cursor:pointer}.location-row .location-underline .location-name{font-family:Oswald,sans-serif;font-weight:300;font-size:24px;color:#184e78;border-bottom:1px solid #184e78;cursor:pointer}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/containers/PORContainer/PORLocationDocuments/AttachmentsTable/LocationRow/LocationRow.scss
// module id = 1763
// module chunks = 0